module.exports = __webpack_public_path__ + "img/pulldown.40f08ded.png";